import { FTProcess } from '@/models/FTProcess';
import { GoodsObject } from '@/models/GoodsObject';
import { FTProcessRow, FTProcessRowTypes } from '@/models/FTProcessRow';

export function goodsName(goods: GoodsObject, processes: FTProcess[]): string {
  if (!goods) {
    return 'N/A'
  }
  const goodHistory = () => {
    if (goods.ftProcessRow && goods.ftProcessRow.parentProcessRow && goods.status !== 'RM' && processes) {
      return ` ${generateNameWithHistory(goods.ftProcessRow.parentProcessRow)}`;
    }
    return '';
  }
  if (typeof goods != 'object') {
    return 'error: Filter used incorrectly';
  }
  const { family, category, mainSpecification, thickness, density, color, supplier, status } = goods;
  const dName = (name?: string | number, unit = '', prepend = '') => name ? `/${prepend}${unit ? name + unit : name}` : '';
  const dimensionsText = getGoodsObjectDimensions(goods);
  const specs = `${dName(mainSpecification)}${dName(thickness, 'micron')}${dName(density, 'GSM')}${dName(color)}${dName((supplier && supplier.name ? supplier.name : '').substring(0, 4))}${dName(dimensionsText)}`
  return `${goods._id}\n${status}${goodHistory()}\n${family}${category ? '/'+category : ''}${specs}`;
}

function generateNameWithHistory(ftProcessRow: FTProcessRow | undefined, rmName : string[] = []) : string {
  if (ftProcessRow && ftProcessRow.parentProcessRow) {
    if (ftProcessRow.parentProcessRow.type === FTProcessRowTypes.output && ftProcessRow.goodsObject) {
      rmName.push(ftProcessRow.ftProcess.type.substring(0, 3).toUpperCase() + '-' + ftProcessRow.goodsObject._id);
    } 
    return generateNameWithHistory(ftProcessRow.parentProcessRow, rmName);
  }
  return rmName.reverse().join('/');
}

function getGoodsObjectDimensions(goodsObject: GoodsObject) : string {
  const { dimensions } = goodsObject;
  let dimText = '';
  if(dimensions) {
    dimText = dimensions.width ? `${dimensions.width}mm` : '';
    if (dimensions.diameter) {
        dimText = dimensions.diameter ? `D${dimensions.diameter}mm` : '';
    } else if (dimensions.area) {
        dimText = dimensions.area ? `A${dimensions.area}mm²` : '';
    } else if (dimensions.length && goodsObject.form !== 'Roll') {
        dimText += `*${dimensions.length}mm`
    }
  }
  return dimText;
}
